import React, { useState, useEffect } from 'react';
import countryCodes from 'country-codes-list';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { makeStyles } from '@material-ui/core';
import { FormHelperText, InputAdornment, TextField } from '@mui/material';
import checkCircle from '../../assets/images/check-circle.svg';
// import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const useStyles = makeStyles({
  textField: {
    width: '100%',
    padding: '0px!important',
    fontSize: '16px!important',
    fontFamily: 'Inter !important',
    fontWeight: '400',
    marginTop: '8px!important',
    transition: '.3s',
    '& .css-1q6at85-MuiInputBase-root-MuiOutlinedInput-root': {
      paddingLeft: '0px!important',
    },
    '& .MuiInputAdornment-root': {
      marginLeft: '0px!important',
      marginRight: '0px!important',
    },
    '& .MuiInputLabel-formControl': {
      fontSize: '14px',
      lineHeight: '1em',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      height: '44px',
      // border: '1px solid #5433FF',
    },
    '& .MuiFormHelperText-root': {
      letterSpacing: '0 !important',
      fontFamily: 'Inter',
      margin: '6px 0 0 0 !important',
      fontWeight: '500',
    },
    '& .MuiOutlinedInput-root .MuiInputBase-input': {
      borderRadius: '8px',
      background: '#fff',
      fontSize: '14px !important',
      // border: '1px solid #D0D5DD',
      //   boxShadow: ' 0px 1px 2px rgb(16 24 40 / 5%)',
      padding: '13.5px 14px',
      transition: '.3s',
      '&:focus': {
        transition: '.3s',
        outline: '0',
        // boxShadow: 'inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%)',
      },
    },
    // '& .MuiOutlinedInput-notchedOutline': {
    //   borderWidth: '0px',
    // },
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  selectForm: {
    '& .MuiInputLabel-formControl': {
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: 'normal',
      letterSpacing: '0',
      padding: '0',
      color: 'inherit',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -8px) scale(0.75)',
    },
  },
  selectField: {
    padding: '0px!important',
    // fontSize: '16px!important',
    background: '#fff',
    fontFamily: 'Inter',
    fontWeight: '400!important',
    boxShadow: ' 0px 1px 2px rgb(16 24 40 / 5%)',
    height: '42px',
    width: '70px',
    '& .MuiFormControl-root': {
      border: '0px solid #d3d3d3!important',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRight: '0px',
      borderRadius: '8px 0 0 8px',
      borderColor: 'rgb(196 196 196 / 0%) !important',
    },
  },
});

const MenuProps = {
  PaperProps: {
    sx: {
      maxWidth: 264,
      paddingBottom: 0,
      background: '#fff',
      color: '#000',
      border: '1px solid #D0D5DD',
      boxShadow: '0px 12px 16px -4px rgb(16 24 40 / 8%), 0px 4px 6px -2px rgb(16 24 40 / 3%)',
      borderRadius: '8px',
      fontWeight: 400,
      fontSize: '14px',
      marginLeft: '6rem',
      maxHeight: 240,
      marginTop: '4px',
      '& .MuiMenuItem-root': {
        marginBottom: 0,
        padding: '8px 14px',
        fontSize: '14px',
        textTransform: 'capitalize',
      },
      '& .MuiList-root': {
        padding: '0',
      },
    },
  },
};

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

function PhoneNumber({ mobileNumber, countryCode, handleDialCode, handlePhoneNumber, disabled = false }) {
  const classes = useStyles();
  const defaultMobile = mobileNumber ?? null;
  const [isValidMobile, setIsValidMobile] = useState(false);
  const [mobile, setMobile] = useState(defaultMobile);
  const options = countryCodes.customList('countryCode', '{countryNameEn} (+{countryCallingCode})');
  const formatted = countryCodes.customList('countryCode', '+{countryCallingCode}');
  const callingCodeTocountryCode = countryCodes.customList('countryCallingCode', '{countryCode}');
  const defaultCountryCode = callingCodeTocountryCode[countryCode?.replace('+', '')] ?? 'IN';
  const [country, setCountry] = useState(defaultCountryCode);

  useEffect(() => {
    if (mobileNumber) {
      if (mobileNumber.match(phoneRegExp) && mobileNumber.length < 14) {
        setIsValidMobile(true);
      } else {
        setIsValidMobile(false);
      }
      handlePhoneNumber(mobileNumber, mobileNumber.match(phoneRegExp) && mobileNumber.length < 14 ? true : false);
    }
  }, [mobileNumber]);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <TextField
          disabled={disabled}
          type="number"
          defaultValue={mobile}
          inputProps={{ maxLength: 12 }}
          onChange={(e) => {
            const number = e.target.value?.trim();
            setMobile(number);
            if (number.match(phoneRegExp) && number.length < 14) {
              setIsValidMobile(true);
            } else {
              setIsValidMobile(false);
            }
            handlePhoneNumber(number, number.match(phoneRegExp) && number.length < 14 ? true : false);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="end">
                <FormControl sx={{ display: 'flex' }} className={classes.selectForm}>
                  <Select
                    disabled={disabled}
                    defaultValue={country}
                    // IconComponent={() => <KeyboardArrowDownIcon fontSize="small" style={{ marginRight: '4px' }} />}
                    labelId="demo-simple-select-label"
                    onChange={(e) => {
                      setCountry(e.target.value);
                      handleDialCode(formatted[e.target.value]);
                    }}
                    inputProps={{ 'aria-label': 'Without label' }}
                    className={classes.selectField}
                    MenuProps={MenuProps}
                    renderValue={() => (
                      <div style={{ display: 'flex' }}>
                        <div>{country ?? 'Select Region'}</div>
                      </div>
                    )}
                  >
                    {Object.keys(options).map((action) => (
                      <MenuItem key={action} value={action}>
                        {options[action]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </InputAdornment>
            ),
            endAdornment: isValidMobile ? (
              <InputAdornment position="end">
                <img src={checkCircle} />
              </InputAdornment>
            ) : (
              ''
            ),
          }}
          placeholder="Phone number here"
          InputLabelProps={{ shrink: false }}
          className={classes.textField}
        />
      </div>
      {!isValidMobile && mobile ? (
        <FormHelperText sx={{ color: '#d32f2f', marginTop: '6px', fontWeight: 500, fontFamily: 'Inter' }}>
          Phone number is not valid!
        </FormHelperText>
      ) : null}
    </div>
  );
}

export default PhoneNumber;
